import { render, staticRenderFns } from "./origin-table-wucai-html-list.vue?vue&type=template&id=7201b99a&"
import script from "./origin-table-wucai-html-list.vue?vue&type=script&lang=js&"
export * from "./origin-table-wucai-html-list.vue?vue&type=script&lang=js&"
import style0 from "./origin-table-wucai-html-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports